// extracted by mini-css-extract-plugin
module.exports = {"legend":"lineChart_legend__1p6rT","label":"lineChart_label__2C7l_","color":"lineChart_color__1HST7"};